import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { PromoTextWithStyleHeading2 } from '~/src/features/internetV2/components/typography';
import HeaderCarousel from '~/src/features/internetV2/containers/SpeedLineContainer/HeaderCarousel';
import SpeedLineContainer from '~/src/features/internetV2/containers/SpeedLineContainer/SpeedLineContainer';

import * as ST from '~/src/features/internetV2/containers/SpeedLineContainer/styled';

interface IMobileSpeedLineContainer {
    children: JSX.Element,
}

const MobileSpeedLineContainer = ({ children }: IMobileSpeedLineContainer): JSX.Element => {
    return (
        <ST.SpeedLineContainer>
            <IndentContainer $united={[0, 0, 32, 0]}>
                <ListContainer $size={0} $direction={'column'}>
                    {children}
                    <PromoTextWithStyleHeading2>Новый интернет Дом.ру:</PromoTextWithStyleHeading2>
                    <HeaderCarousel>
                        <PromoTextWithStyleHeading2>стабильный</PromoTextWithStyleHeading2>
                        <PromoTextWithStyleHeading2>быстрый</PromoTextWithStyleHeading2>
                        <PromoTextWithStyleHeading2>умный</PromoTextWithStyleHeading2>
                    </HeaderCarousel>
                </ListContainer>
            </IndentContainer>

            <SpeedLineContainer />
        </ST.SpeedLineContainer>
    );
};

export default MobileSpeedLineContainer;
